import { TOP_NAV_ITEMS } from "Components/Navigation/TopNavigation/TopNavigationData2";
import NavMenu from "./NavMenu";
import NavItem from "./NavItem";
import { Nav } from "react-bootstrap";

const NavBar = () => {
  return (
    <Nav id="topNav"  >
      {TOP_NAV_ITEMS.map((item, index) => {
        if (item.type === "listItem") {
          return <NavItem classNames="body semibold lh-1" key={"topRespNav" + index} listItemTitle={item.title} listItemLink={item.link} ></NavItem>
        }
        if (item.type === "subMenu") {
          return <NavMenu key={"topRespNav" + index} subMenuButtonTitle={item.title} menuId={item.id} subMenuItems={item.items} align={item.align}></NavMenu>
        }
      })}
    </Nav>
  )
}

export default NavBar;